import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import {off, on, publish} from 'services/PubSub';

import './GestureControl.css';

const GestureControl = () => {
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    const listener = () => {
      setDisabled(true);
    };
    on('face_control', listener);
    return () => off('face_control', listener);
  }, []);

  function handleClick() {
    const shouldDisable = !disabled;

    publish('gesture_control', shouldDisable);

    setDisabled(shouldDisable);
  }

  return (
    <button
      className={classNames('gesture-control', { 'gesture-control__disabled': disabled })}
      onClick={handleClick}
      title={disabled ? 'Enable gesture recognition' : 'Disable gesture recognition'}
    />
  );
};

export default GestureControl;
